import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  };

  const next = () => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  };

  const t = testimonials[current];

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-2xl mx-auto text-center">
          <span className="font-heading text-lg italic text-foreground-500">
            (What Our Community Says)
          </span>

          <div className="mt-10 flex flex-col items-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-foreground-900 text-background-50 rounded-full text-xs font-semibold mb-6">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
              </span>
              <span>4.9 / 5.0</span>
            </div>

            <blockquote className="font-heading text-lg md:text-xl italic text-foreground-800 leading-relaxed max-w-xl">
              &ldquo;{t.text}&rdquo;
            </blockquote>

            <div className="flex items-center gap-3 mt-8">
              <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.location}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={prev}
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-300 text-foreground-600 hover:bg-background-100 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line text-lg"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors duration-200 cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>

            <div className="flex items-center gap-2 mt-4">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    i === current ? 'bg-primary-500 w-6' : 'bg-background-300 hover:bg-background-400'
                  }`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}